import { ReactNode, PropsWithChildren } from 'react';
import { colors, r8, s64 } from '@ardoq/design-tokens';
import { SvgImageName } from '@ardoq/icons';
import styled from 'styled-components';
import { LoadingScreenLogo } from '../LoadingScreen/LoadingScreenLogo';
import { FlexBox } from '../FlexBox/FlexBox';
import { Text } from '@ardoq/typography';
import { Box } from '../Box/Box';

const Wrapper = styled.div`
  background-color: ${colors.surfaceBrand};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.surfaceDefault};
  border-radius: ${r8};
`;

const Content = styled.div<{ $hasNotification: boolean }>`
  padding: ${s64};
  padding-top: ${props => (props.$hasNotification ? 0 : undefined)};
  display: flex;
  flex-direction: row;
`;

const Background = styled.div`
  display: flex;
  min-width: 456px;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
`;

const getWidth = (logoName: SvgImageName) => {
  switch (logoName) {
    case SvgImageName.ARDOQ_DISCOVER_LOGO_WITH_NAME:
      return 173;
    default:
      return undefined;
  }
};

type ContainerProps = {
  logoName?: SvgImageName;
  notification?: ReactNode;
  footer?: ReactNode;
};

export const Container = ({
  logoName = SvgImageName.ARDOQ_LOGO_WITH_NAME,
  notification,
  footer,
  children,
}: PropsWithChildren<ContainerProps>) => (
  <Wrapper>
    <LoadingScreenLogo
      color={colors.brand950}
      width={getWidth(logoName)}
      svgImageName={logoName}
    />
    <FlexBox
      justify="center"
      align="center"
      flex={4}
      style={{ marginTop: '120px' }}
    >
      <Background>
        <ContentWrapper>
          {notification && (
            <Box
              marginBottom="medium"
              padding="medium"
              style={{ width: '463px' }}
            >
              {notification}
            </Box>
          )}
          <Content $hasNotification={!!notification}>{children}</Content>
        </ContentWrapper>
      </Background>
    </FlexBox>
    <FlexBox flex={1}>&nbsp;</FlexBox>
    <FlexBox paddingY="small" paddingX="xlarge" justify="center" width="full">
      <Text color="textOnInverted">{footer}</Text>
    </FlexBox>
  </Wrapper>
);
